import { gql } from '@apollo/client'

export const SABRE_GET_PACKAGING_QUANTITY_OPTIONS = gql`
  query GetPackagingQuantityOptions($input: PackagingOptionQueryInput) {
    packagingQuantities(input: $input) {
      count
      hasMore
      results
    }
  }
`
